"use strict";

angular.module("admin")
	.controller("AdminNetexExportMonitoringCtrl", ["exportTemplateDetail", "$scope", "$interval", "$route", "AdminClientsService", "OpenExportsService", "$log",
		function (exportTemplateDetail, $scope, $interval, $route, AdminClientsService, OpenExportsService, $log) {
		const vm = this;
		vm.data = {
			exportType: "",
			exportTemplateName: "",
			exportedFileName: "",
			referentialId: -1,
			monitoringToDisplay: [],
			exportNumberToDisplay: 20,
			adminReferential: "technique",
			displayExportFileToConsumer: false,
		};

		if (exportTemplateDetail.status === 200) {
			vm.data.exportTemplateName = exportTemplateDetail.data.name;
			vm.data.exportType = exportTemplateDetail.data.type;
			vm.data.displayExportFileToConsumer = exportTemplateDetail.data.consumers.length > 0;
			vm.data.exportedFileName = exportTemplateDetail.data.exportedFileName;
		}


		vm.mapDate = function (timestamp) {
			const date = new Date(timestamp);
			return date.toLocaleString("fr-FR");
		};

		vm.findFileLink = function (job) {
			let result = null;
			if (angular.isArray(job.links)) {
				let targetJob = job.links.find(link => link.rel === "data");
				if (targetJob) {
					result = targetJob.href;
				}
			}
			return result;
		};


		vm.getFileNameFromUrl = function (urlString) {
			let result = "";
			if (urlString) {
				result = urlString.split("/").pop();
			}
			return result;
		};

		vm.buildMonitoringToDisplay = function (jobDetail) {
			const id = jobDetail.id;
			const startDate = vm.mapDate(jobDetail.started * 1000);
			const globalStatus = jobDetail.status;
			let url = vm.findFileLink(jobDetail);
			let generatedFile = jobDetail.fileName;
			return {
				id,
				startDate,
				url,
				globalStatus,
				generatedFile
			};
		};

		vm.updateConsumerExportInfo = function (jobDetail, allConsumerEvents) {
			jobDetail.depositeState = [];
			if (angular.isArray(allConsumerEvents)) {
				allConsumerEvents.forEach(exportDetail => {
					if (angular.isArray(exportDetail.events)) {
						exportDetail.events.forEach(event => {
							const tiamatJobId = event.chouetteJobId;
							if (event.action === "EXPORT_TO_CONSUMER" && jobDetail.id === tiamatJobId) {
								jobDetail.depositeState = [];
								jobDetail.deposite = vm.data.exportedFileName;
								if (event.description) {
									const exportToConsumer = [];
									const exportsFileInfo = event.description.split(";");
									if (angular.isArray(exportsFileInfo)) {
										exportsFileInfo.forEach(consumer => {
											const info = consumer.split(",");
											if (angular.isArray(info) && info.length === 3) {
												exportToConsumer.push({type: info[0], state: info[1], name: info[2]});
											}
										});
										jobDetail.depositeState = exportToConsumer;
									}
								}
							}
						});
					}
				});
			}
		};

		vm.keepLatestJobs = function(dataArray) {
			const jobIds = Array.from(dataArray);
			jobIds.sort((a, b) => b - a);
			const sliceIndex = Math.min(jobIds.length, 20);
			return jobIds.splice(0, sliceIndex);
		};

		vm.fetchData = function () {
			let jobInfoPromise = null;
			switch (vm.data.exportType) {
			case "PARKING":
				jobInfoPromise = OpenExportsService.getAllTiamatJobByType("NETEX_PARKING");
				break;
			case "POI":
				jobInfoPromise = OpenExportsService.getAllTiamatJobByType("NETEX_POI");
				break;
			case "ARRET":
				jobInfoPromise = OpenExportsService.getAllTiamatJobByType("NETEX_STOP_PLACE_QUAY");
				break;
			default:
				break;
			}

			if (jobInfoPromise) {
				jobInfoPromise.then((response) => {
					vm.data.monitoringToDisplay = [];
					if (response.status === 200) {
						if (vm.data.displayExportFileToConsumer) {
							const actionFilter = ["EXPORT_TO_CONSUMER"];
							const jobs = response.data.map(job => job.id);
							const filteredJob = vm.keepLatestJobs(jobs);
							const rawJobData = response.data;
							OpenExportsService.getExportToConsumerEventByJobs(vm.data.referentialId, actionFilter, filteredJob)
								.then(consumerInfo => {
									rawJobData.forEach(exportJob => {
										const jobToDisplay = vm.buildMonitoringToDisplay(exportJob);
										if (consumerInfo.status === 200) {
											vm.updateConsumerExportInfo(jobToDisplay, consumerInfo.data);
										}
										vm.data.monitoringToDisplay.push(jobToDisplay);
									});
								});
						} else {
							response.data.forEach(data => {
								vm.data.monitoringToDisplay.push(vm.buildMonitoringToDisplay(data));
							});
						}
					}
				});
			}
		};

		AdminClientsService.getReferentialId().then(data => {
			if (data) {
				vm.data.referentialId = data;

				vm.fetchData();

				vm.data.pollingReference = $interval(vm.fetchData, 10000);
			}
		});

		vm.downloadFile = function (filepath) {
			OpenExportsService.getStopPlaceFile("technique", filepath)
				.then((response) => {
					let blob = new Blob([response.data], {type: "octet/stream"});
					let a = document.createElement("a");
					a.href = (window.URL || window.webkitURL).createObjectURL(blob);
					a.target = "_blank";
					a.download = filepath;
					document.body.appendChild(a);
					a.click();
				}).catch(function () {
					$log.error("Le fichier est introuvable sur le serveur.", "Problème lors du téléchargement");
				});
		};


		$scope.$on("$destroy", () => {
			if (vm.data.pollingReference) {
				$interval.cancel(vm.data.pollingReference);
			}
		});

	}]);